$('.sign-out').on('click', storeChangeToDefault);
$('.account_logged').on('click', storeChangeToDefault);

function profileMenuClick(link, buttonText) {
    analytics.profileLinksClickAnalytics(buttonText);
    window.location.href = link;
}
function signoutClick(link) {
    analytics.profileSignOutClick();
    orderViewModel.currentOrder.cartId = '';
    orderViewModel.currentOrder.cartQuantity = 0;
    orderViewModel.save();
    window.location.href = '/' + link;
}
